export default __webpack_public_path__ + "static/tab-client001-e1b48a5c3384f174931b336992137955.png";